import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DiaryData } from '../../providers/diary';
import { SpeakerData } from '../../providers/speaker';
import { Tracking } from '../../providers/tracking';
import { EventDiaryPage } from '../event-diary/event-diary';
import { EventSpeakerPage } from '../event-speaker/event-speaker';

@Component({
  selector: 'page-event-favorite',
  templateUrl: 'event-favorite.html'
})
export class EventFavoritePage {

  /**
   * Child /Clients/$clientId/___favorites/$uid/
   * @param navCtrl
   * @param params
   */

  obs1: any;
  obs2: any;
  obs3: any;
  client: any;
  event: any;
  favorites: any;
  favoriteDiary: any;
  favoriteSpeaker: any;
  favoriteResource: any;

  constructor(public navCtrl: NavController, public params: NavParams, public diaryProvider: DiaryData, public speakerProvider: SpeakerData, public track: Tracking) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.favorites = 'diary';

    this.obs1 = this.diaryProvider.getFavorites(this.client).subscribe((data) => {
      this.favoriteDiary = data;
    });

    this.obs2 = this.speakerProvider.getFavorites(this.client).subscribe((data) => {
      this.favoriteSpeaker = data;
    });

    this.obs3 = this.speakerProvider.getResourceFavorites(this.client).subscribe((data) => {
      this.favoriteResource = data;
    });
  }

  viewDiary(diary) {
    this.navCtrl.push(EventDiaryPage, {'event': this.event, 'diary': diary, client: this.client});
  }

  viewSpeaker(speaker) {
    this.navCtrl.push(EventSpeakerPage, {speaker: speaker, event: this.event, client: this.client});
  }

  viewResource(resource) {
    this.track.saveTrackingResource(this.client, this.event.id, resource.speakerId, resource.id)
    .then(() => {
        window.open(
          resource.url,
          '_blank'
        );
    })
    .catch((error) => {
      this.track.trackError('Resource', error);
    });
  }

  closeListener() {
    console.log('Se eliminan los observable de page-favorite', 'obs1', 'obs2', 'obs3');
    this.obs1.unsubscribe();
    this.obs2.unsubscribe();
    this.obs3.unsubscribe();
  }

  // Unsubsucribe observables on exit page
  ionViewWillUnload() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-favorite/event-favorite.ts